export const ROUTE_ACTIVITY = '/activity';

export const ACTIVITY_DATE_FILTER_OPTIONS = [
  { value: 'last-24-hours', hoursAgo: 24 },
  { value: 'last-7-days', hoursAgo: 24 * 7 },
  { value: 'last-30-days', hoursAgo: 24 * 30 },
] as const;

export type ActivityDateFilterValue = (typeof ACTIVITY_DATE_FILTER_OPTIONS)[number]['value'];
